import React from "react";

const Abandon = () => (
  <div className="Information">
    <span>Applikasjonen er avsluttet.</span>
  </div>
);

export default Abandon;
